import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { SelectionModel } from "@angular/cdk/collections";
import {AccessService, LocalStoreService, StoreSelectorsService} from "../../../services";
import { SpecialCompbaser } from "../../../components/compbaser";
import {ExperienceLevelType, IAccessTable, IResource} from "../../../interfaces";
import { MatTabGroup } from "@angular/material/tabs";
import { MatDialog } from "@angular/material/dialog";
import {isHostDevOrLocal} from "../../../common";
import {filter} from "rxjs/operators";

@Component({
    selector: 'app-root',
    templateUrl: 'resources.component.html',
    styleUrls: ['resources.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResourcesComponent extends SpecialCompbaser {
    @ViewChild("tabs", { static: false }) tabs: MatTabGroup;

    resources: IResource[];
    selectionModel: SelectionModel<number>;
    accessConfig: IAccessTable;

    /** SignStudio AI privilege cherry-pick toggles. MUST default to true — the privileges
     *  observable may never emit (free users / legacy XML without the group) and in every
     *  such case the AI tabs stay visible. Only an explicit '0' set by a reseller hides
     *  a tab. See docs/09-adding-privilege-feature-toggles.md */
    aiMediaProducerEnabled = true;
    aiAnimatorEnabled = true;
    aiVideoBuilderEnabled = true;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    constructor(
        private storeSelector: StoreSelectorsService,
        private accessService: AccessService,
        private cd: ChangeDetectorRef,
        dialog: MatDialog,
        private localStoreService: LocalStoreService) {
        super(dialog);

        this.cod(
            this.accessService.getGroupsTable('SignStudio Resources', "resources").subscribe((v) => {
                this.accessConfig = v;
            })
        );
        this.cod(
            this.accessService.getGroupsCollection('SignStudio AI').subscribe((group) => {
                /** group is null for free users / legacy XML → all default to enabled */
                this.aiMediaProducerEnabled = group?.$?.aiMediaProducer !== '0';
                this.aiAnimatorEnabled = group?.$?.aiAnimator !== '0';
                this.aiVideoBuilderEnabled = group?.$?.aiVideoBuilder !== '0';
                this.cd.markForCheck();
            })
        );
        this.cod(
            this.storeSelector.getResources().subscribe((r) => {
                this.resources = r;
                this.cd.markForCheck();
            })
        );

        this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
        this.cod(
            this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
                this.cd.markForCheck();
            })
        );
    }

    onSwitchFileTab() {
        this.tabs.selectedIndex = 1;
    }
}
